import { toast } from 'react-toastify';

import { IToastService } from '@/interfaces/services/IToastService';

export function success(message: string) {
	toast.success(message, {
		position: 'bottom-right',
	});
}
export function error(message: string) {
	toast.error(message, {
		position: 'bottom-right',
	});
}
export function warning(message: string) {
	toast.warning(message, {
		position: 'bottom-right',
	});
}
export function confirm(message: string, onConfirm: () => void) {
	toast.warn(
		({ closeToast }) => (
			<div className="flex flex-col gap-2">
				<p className="text-center">{message}</p>
				<button
					data-test="toast-confirm-button"
					className="bg-blue-600 rounded-md px-4 py-1 text-white w-full hover:bg-blue-500 font-medium"
					onClick={() => {
						onConfirm();
						closeToast();
					}}
				>
					Confirm
				</button>
			</div>
		),
		{
			position: 'top-center',
			autoClose: false,
		},
	);
}
export const reactToastifyService: IToastService = {
	success,
	error,
	warning,
	confirm,
};
